/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Component } from 'react'
import { defineMessages, injectIntl } from 'react-intl'

import { EuiLoadingSpinner, EuiSwitch } from '@elastic/eui'

import { CuiAlert } from '@modules/cui/Alert'

import type { WrappedComponentProps } from 'react-intl'
import type { AllProps } from './types'

const messages = defineMessages({
  labelAllowed: {
    id: `allow-use-deprecated-resources.status.checkbox-label-allowed`,
    defaultMessage: `Allowed`,
  },
  labelNotAllowed: {
    id: `allow-use-deprecated-resources.status.checkbox-label-not-allowed`,
    defaultMessage: `Not Allowed`,
  },
})

class AllowUseDeprecatedResources extends Component<AllProps & WrappedComponentProps> {
  componentDidMount(): void {
    this.props.fetchOrganizationConfiguration()
  }

  render() {
    const {
      intl: { formatMessage },
      fetchOrganizationConfigurationRequest,
      updateOrganizationConfigurationRequest,
      organizationId,
      isAllowedToUseDeprecatedResources,
    } = this.props

    if (organizationId === ``) {
      return null
    }

    if (
      fetchOrganizationConfigurationRequest.error ||
      updateOrganizationConfigurationRequest.error
    ) {
      return (
        <CuiAlert data-test-id='allow-use-deprecated-resources-error' type='error'>
          {fetchOrganizationConfigurationRequest.error}
        </CuiAlert>
      )
    }

    if (
      fetchOrganizationConfigurationRequest.inProgress ||
      updateOrganizationConfigurationRequest.inProgress
    ) {
      return <EuiLoadingSpinner data-test-id='allow-use-deprecated-resources-loading' />
    }

    return (
      <EuiSwitch
        label={formatMessage(
          isAllowedToUseDeprecatedResources ? messages.labelAllowed : messages.labelNotAllowed,
        )}
        data-test-id='allow-use-deprecated-resources-switch'
        checked={isAllowedToUseDeprecatedResources}
        onChange={() =>
          this.props.setAllowToUseDeprecatedResources(!isAllowedToUseDeprecatedResources)
        }
      />
    )
  }
}

export default injectIntl(AllowUseDeprecatedResources)
